(() => {
  if (!window.Lenis) return;

  const lenis = new Lenis({
    autoRaf: true,
    anchors: true,
    lerp: 0.1,
    wheelMultiplier: 1,
    touchMultiplier: 1.15,
    smoothWheel: false,
    syncTouch: false,
    stopInertiaOnNavigate: true,
    respectReducedMotion: true
  });

  window.maksttonLenis = lenis;

  const annotationRootId = 'codex-browser-sidebar-comments-root';
  let annotationRoot = null;
  let annotationObserver = null;

  const isAnnotationActive = () => {
    if (!annotationRoot) return false;
    return annotationRoot.childElementCount > 0
      || annotationRoot.matches('.active, .is-active, [data-active="true"], [aria-hidden="false"]');
  };

  const syncAnnotationMode = () => {
    const active = isAnnotationActive();
    document.documentElement.classList.toggle('codex-annotate-active', active);
    document.documentElement.classList.toggle('lenis-disabled', active);

    if (active) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  const bindAnnotationRoot = () => {
    const root = document.getElementById(annotationRootId);
    if (!root || root === annotationRoot) return;

    annotationRoot = root;
    annotationObserver?.disconnect();
    annotationObserver = new MutationObserver(syncAnnotationMode);
    annotationObserver.observe(root, {
      attributes: true,
      attributeFilter: ['class', 'style', 'data-active', 'aria-hidden'],
      childList: true
    });
    syncAnnotationMode();
  };

  const rootObserver = new MutationObserver(bindAnnotationRoot);
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });
  bindAnnotationRoot();
})();
